import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { EnergyRevenuesListResponse } from "../RevenueMonitoring.types";
import { ensureListResponse } from "./ensureListResponse";

export function useGeneratorEnergyRevenuesData(
  generatorIds?: Array<number>,
  options?: Partial<UseQueryOptions<EnergyRevenuesListResponse>>
) {
  const sortedGeneratorIds = generatorIds ? [...generatorIds.sort()] : [];

  return useQuery({
    queryKey: ["energyRevenuesData", { generatorIds: sortedGeneratorIds }],
    queryFn: ({ client, queryKey }) =>
      fetchEnergyRevenuesData(
        sortedGeneratorIds,
        // Kept on screen if a refetch returns a non-array body
        client.getQueryData<EnergyRevenuesListResponse>(queryKey)
      ),
    enabled: !!generatorIds && generatorIds.length > 0,
    retry: false,
    ...options
  });
}

async function fetchEnergyRevenuesData(
  generatorIds: Array<number> | undefined,
  cachedData: EnergyRevenuesListResponse | undefined
) {
  if (!generatorIds || generatorIds.length === 0) return [];

  const revenueMonitoringPerPersonUrl =
    urls.apiWithoutCamelization.revenueMonitoringPerGenerator({
      generatorIds
    });
  const response = await apiWithoutCamelization.get<unknown>(
    revenueMonitoringPerPersonUrl
  );
  return ensureListResponse(response, "generator", cachedData);
}
